<template>
  <v-dialog v-model="dialog" persistent max-width="500px">
    <v-card>
      <v-card-title>
        <h2>Naujas produktas</h2>
      </v-card-title>

      <v-card-text>
        <v-container grid-list-md>
          <v-layout wrap>
            <v-flex xs12 sm6 md4>
              <v-text-field
                v-model="editedItem.position"
                type="text"
                :label="$t('products_crud.position')"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm6 md4>
              <v-text-field v-model="editedItem.type" type="text" :label="$t('products_crud.type')"></v-text-field>
            </v-flex>
            <v-flex xs12 sm6 md4>
              <v-text-field
                v-model="editedItem.width"
                type="number"
                :label="$t('products_crud.width')"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm6 md4>
              <v-text-field
                v-model="editedItem.height"
                type="number"
                :label="$t('products_crud.height')"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm6 md4>
              <v-text-field
                v-model="editedItem.depth"
                type="number"
                :label="$t('products_crud.depth')"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm6 md4>
              <v-text-field
                v-model="editedItem.weight"
                type="number"
                :label="$t('products_crud.weight')"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm6 md4>
              <v-text-field
                v-model="editedItem.area"
                type="number"
                :label="$t('products_crud.area')"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm6 md4>
              <v-text-field
                v-model="editedItem.comment"
                type="text"
                :label="$t('products_crud.comment')"
              ></v-text-field>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" flat @click="save">{{ $t("products_crud.save") }}</v-btn>
        <v-btn color="blue darken-1" flat @click="dialog = false">{{ $t("products_crud.cancel") }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import Product from "@/models/Product.js";
export default {
  data() {
    return {
      dialog: false,
      editedItem: {},
      onKeyUp: e => {
        if (e.key == "Escape") {
          this.dialog = false;
        }
        if (e.key == "Enter") {
          this.save();
        }
      },
      order: null
    };
  },
  watch: {
    dialog(val) {
      if (val) {
        this.keyUpHandler = this.onKeyUp.bind(this);
        document.addEventListener("keyup", this.keyUpHandler);
      } else {
        document.removeEventListener("keyup", this.keyUpHandler);
      }
    }
  },
  methods: {
    open(order, selected) {
      this.order = order;
      if (selected.length == 1) {
        this.editedItem = new Product(selected[0]);
      } else {
        this.editedItem = {};
      }
      this.dialog = true;
    },
    async save() {
      const data = this.formData(this.editedItem, this);
      if (this.validateData(data)) {
        data.barcode = this.getBarcode();
        await Product.create(data);
        this.$emit("created");
      } else {
        alert(this.$t("products_crud.product_request_error"));
      }
      this.dialog = false;
    },

    getBarcode() {
      const orderNumber = this.getOrderNumber();
      const positionNumber = "999";
      const count = this.getCounter();
      return `${orderNumber}${positionNumber}${count}`;
    },

    getCounter() {
      let counter = "1";
      const count = this.order.additional_products_count;
      const digitsCount = count.toString().length;
      for(let i = 0; i < 3 - digitsCount; i++){
        counter += "0";
      }
      return `${counter}${count + 1}`;
    },

    getOrderNumber() {
      let number = this.order.production_id
        ? this.order.production_id.substr(0, 7)
        : this.order.offer_id.substr(0, 7);
      while (number.length < 8) {
        number += ".";
      }
      return number;
    },

    /**
     * validates data before send
     *
     * @param data - data to be checked
     */
    validateData(data) {
      let Validator = require("validatorjs");
      let rules = {
        area: "required|numeric",
        depth: "required|integer",
        height: "required|integer",
        isFlipped: "boolean",
        palletId: "integer",
        position: "required|string|min:1|max:64",
        type: "min:1|max:191",
        weight: "required|integer",
        width: "required|integer",
        x: "integer",
        y: "integer",
        z: "integer"
      };
      let validation = new Validator(data, rules);
      return validation.passes() ? true : false;
    },

    /**
     * formats data before sending to the database
     *
     * @param product - product obj
     */
    formData(product) {
      let data = {
        status: product.status,
        order_id: this.order.id
      };
      if (product.position != null) data["position"] = product.position;
      if (product.barcode != null) data["barcode"] = product.barcode;
      if (product.type != null) data["type"] = product.type;
      if (product.height != null) data["height"] = product.height;
      if (product.width != null) data["width"] = product.width;
      if (product.depth != null) data["depth"] = product.depth;
      if (product.weight != null) data["weight"] = product.weight;
      if (product.palletId != null) data["palletId"] = product.palletId;
      if (product.x != null) data["x"] = product.x;
      if (product.y != null) data["y"] = product.y;
      if (product.z != null) data["z"] = product.z;
      if (product.isFlipped != null) data["isFlipped"] = product.isFlipped;
      if (product.area != null) data["area"] = product.area;
      if (product.comment != null) data["comment"] = product.comment;
      return data;
    }
  }
};
</script>

<style></style>
